import api from './api_config';

export default {
  async getProducts(expDiv, pgDiv, pdEnd) {
    return api.get(`/api/product?pdDiv=${expDiv}&pgDiv=${pgDiv}` + (pdEnd ? `&pdEnd=${pdEnd}` : ''));
  },
  async getProduct(id, pgDiv, expVisitRvdt, mrktnScheSeqNo, d, t) {
    let param = `pgDiv=${pgDiv}`;
    if (expVisitRvdt) {
      param += `&expVisitRvdt=${expVisitRvdt}`;
    }
    if (mrktnScheSeqNo) {
      param += `&mrktnScheSeqNo=${mrktnScheSeqNo}`;
    }
    if (d) {
      param += `&d=${encodeURIComponent(d)}`;
    }
    if (t) {
      param += `&t=${t}`;
    }
    return api.get(`/api/product/${id}?${param}`);
    //return api.get('/api/product/' + id + '?pgDiv=' + pgDiv);
  },
  async getProductSchedule(id, pgDiv, expVisitRvdt, mrktnScheSeqNo, d, t) {
    let param = `pgDiv=${pgDiv}&expVisitRvdt=${expVisitRvdt}`;
    if (mrktnScheSeqNo) {
      param += `&mrktnScheSeqNo=${mrktnScheSeqNo}`;
    }
    if (d) {
      param += `&d=${encodeURIComponent(d)}`;
    }
    if (t) {
      param += `&t=${t}`;
    }

    return api.get(`/api/product/${id}?${param}`);
  },
};

export async function getMakiveStreet() {
  return await api.get('/api/product/makivestreet');
}
